import { Row } from 'react-bootstrap'
import RecordingCard from './RecordingCard'
import { useContext } from 'react'
import { PlayerContext } from '../../pages/Home'

const RecordingList = ({ recordingList }) => {
  const { playRecordings } = useContext(PlayerContext)

  if (!recordingList) return ''

  const playFn = (index) => {
    playRecordings(recordingList, index)
  }

  return (
    <Row className='g-4 flex-nowrap pb-3 recording-carousel'>
      {recordingList.map((recording, i) => (
        <RecordingCard
          recording={recording}
          key={recording.name}
          index={i}
          playFn={playFn}
        />
      ))}
    </Row>
  )
}
export default RecordingList
